<template>
    <v-toolbar dark color="primary" dense>
        <v-btn icon v-on:click="$router.back()">
            <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-items>
            <v-btn flat v-on:click="logout">Logout</v-btn>
        </v-toolbar-items>
    </v-toolbar>
</template>

<script>
    export default {
        methods: {
            logout() {
                localStorage.removeItem("isLogedIn") 
                this.$router.push('/login')
            }
        }
    }
</script>